<div style="width: 100%;">
    <ng-container *ngIf="isOpened">
        <input
            #searchBar
            [ngClass]="{'loading': isLoading}"
            placeholder="Location"
            aria-label="Location"
            spellcheck="false"
            [matAutocomplete]="auto"
            (blur)="onSearchbarBlur()"
            [formControl]="locationCtrl"
            appAutoFocus>
        <mat-autocomplete
            #auto="matAutocomplete"
            autoActiveFirstOption
            (optionSelected)="selectLocation($event.option.value)"
            [displayWith]="displayFn">
            <mat-option
                *ngFor="let location of locations"
                [value]="location">
                    {{ location.description }}
            </mat-option>
        </mat-autocomplete>
    </ng-container>
    <div class="spacer"></div>
    <span *ngIf="!isOpened" class="button-container">
        <ng-content></ng-content>
        <button mat-icon-button (click)="toggleSearching()">
            <mat-icon>search</mat-icon>
        </button>
    </span>
</div>
